var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"note-disclaimer d-flex align-items-start"},[_c('span',{staticClass:"fa-bg"},[_c('i',{staticClass:"fa fa-exclamation"})]),_c('span',[_vm._v(" Please complete the dependent information above, or click Cancel to proceed ")])])])
}]

export { render, staticRenderFns }